import { Divider, Row } from "antd";
import { PageTitle } from "components/Shared/PageTitle";
import { useFetchCustomers } from "hooks/useUsersApi";
import type React from "react";
import { useState } from "react";
import { useIntl } from "react-intl";
import { BaseEntityCard } from "./components/BaseEntityCard";
import { SelectTable } from "./SelectTable";

export const SelectCustomerPage: React.FC<any> = () => {
  const { formatMessage } = useIntl();
  const [searchText, setSearchText] = useState("");
  const { isLoading, data: customersResponse } = useFetchCustomers();
  const customers = customersResponse?.data || [];
  const filteredCustomers = customers.filter(
    (x: any) => x?.displayName?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1
  );

  return (
    <>
      <Row className="mt-15" justify="space-between">
        <PageTitle isLoading={false} title={formatMessage({ id: "selectCustomerPage.title" })} />
      </Row>
      <Divider />
      <Row justify="center">
        <SelectTable
          isLoading={isLoading}
          items={filteredCustomers}
          validations={[
            {
              message: formatMessage({ id: "selectCustomerPage.noAccess" }),
              check: () => customers.length === 0,
            },
          ]}
          onSearch={setSearchText}
          render={(x: any) => (
            <BaseEntityCard
              key={x?.customerId}
              to={`/${x?.customerId}`}
              name={x?.displayName}
              desc={`Code: ${x?.code}`}
            />
          )}
        />
      </Row>
    </>
  );
};
